export default "<app-statistics></app-statistics>\r\n";